import { render, staticRenderFns } from "./PufaLoan.vue?vue&type=template&id=b81608c6&scoped=true"
import script from "./PufaLoan.vue?vue&type=script&lang=js"
export * from "./PufaLoan.vue?vue&type=script&lang=js"
import style0 from "./PufaLoan.vue?vue&type=style&index=0&id=b81608c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81608c6",
  null
  
)

export default component.exports